/*
* classname: 自定义class
* url: 图片路径
* width: 图片宽度  数值(rem) / auto
* height: 图片高度   数值(rem) / auto
* fit: 图片填充模式 contain:全部展示(按长边等比缩放)  cover:全部展示(按短边等比缩放，超出部分会被裁剪)  fill:全部展示(不等比缩放)
* loadbgColor: loading背景颜色
* loadColor: loading颜色
* loadSize: loading的尺寸px
* borderRadius: 倒角值
* overflow: overflow属性
* curData: 当前的对象（用于判断当前点击的是哪个对象）
* dateTemp: 图片路径是否加时间戳
* showLoading: 是否展示Loading
* isStopprev: 是否需要阻止冒泡
* children:  父组件传过来的元素（相当于slot）
* callback: 回调函数
*/ 

import { Image, SpinLoading } from 'antd-mobile'
import { useEffect, useState } from 'react'
import './com-image.less'

const ComImage = ({ classname='', url='', width, height, fit='contain', loadbgColor='#fff', loadColor='#ccc', loadSize='0.34', borderRadius='0', overflow='hidden', curData={}, dateTemp=true, showLoading=true, isStopprev=false, children, callback }) => {
  
  const [state, setState] = useState({
    imgUrl: '',
    isLoad: false,
    overflowVal: 'visible'
  })
  useEffect(() => {
    setData({ imgUrl: url && url!='true' ? `${url}${dateTemp ? ('?temp=' + Date.now()) : ''}` : '' });
  }, [url])
  
  const setData = (obj={}) => {
    setState(st => ({ ...st, ...obj }));
  }
  const loadFun = () => {
    setData({ isLoad: true, overflowVal: overflow });    //加载失败的时候，设置为hidden，会导致loading不显示
    callback && callback('load', curData);
  }
  const errorFun = () => {
    callback && callback('error');
  }
  const tapImgs = (e) => {
    if (isStopprev) e.stopPropagation();
    callback && callback('click', curData);
  }

  return (
    <div className={`com-image-wrap ${classname}`} style={{width:width?(width+(width=='auto'?'':'rem')):'100%', height:height?(height+(height=='auto'?'':'rem')):'100%', borderRadius:borderRadius+'rem', overflow:state.overflowVal}}>
      { state.imgUrl ? <Image className="com-imgs" fit={fit} src={state.imgUrl} onClick={tapImgs} onLoad={loadFun} onError={errorFun}></Image> : '' }
      { !showLoading || state.isLoad ? '' :
        <div className="com-imgloadbg" style={{width:width&&width!='auto'?(width+'rem'):'100vw', height:height&&height!='auto'?(height+'rem'):'100vh', background:loadbgColor}}>
          <SpinLoading className="com-imgloading" style={{'--size': loadSize+'rem'}} color={loadColor} />
        </div>
      }
      { children && (!showLoading || state.isLoad) ? children : '' }
    </div>
  )
}

export default ComImage;